import * as THREE from 'three'

export interface CameraPositionData {
  position: [number, number, number]
  lookAt: [number, number, number]
}

export const getCameraPositionAndLookAt = (
  camera: THREE.PerspectiveCamera | null,
  lookAtDistance: number = 10
): CameraPositionData | null => {
  if (!camera) return null

  const position = camera.position
  const direction = new THREE.Vector3()
  camera.getWorldDirection(direction)

  const targetPoint = new THREE.Vector3()
  targetPoint.copy(position).addScaledVector(direction, lookAtDistance)

  return {
    position: [position.x, position.y, position.z],
    lookAt: [targetPoint.x, targetPoint.y, targetPoint.z],
  }
}

export const getCameraPositionString = (
  camera: THREE.PerspectiveCamera | null
): string => {
  if (!camera) return ''

  const pos = camera.position
  return `${pos.x.toFixed(2)}, ${pos.y.toFixed(2)}, ${pos.z.toFixed(2)}`
}

export const getCameraLookAtString = (
  camera: THREE.PerspectiveCamera | null,
  lookAtDistance: number = 10
): string => {
  if (!camera) return ''

  const direction = new THREE.Vector3()
  camera.getWorldDirection(direction)

  const targetPoint = new THREE.Vector3()
  targetPoint.copy(camera.position).addScaledVector(direction, lookAtDistance)

  return `${targetPoint.x.toFixed(2)}, ${targetPoint.y.toFixed(2)}, ${targetPoint.z.toFixed(2)}`
}
